import { Option } from './interfaces/option.interface';
import { debounceTime, tap } from 'rxjs/operators';
import * as moment from 'moment';
import { AppConfigService } from '../app/services/app-config.service';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';

export const LANGUAGES = [
    { value: 'de', label: 'GERMAN'},
    { value: 'en', label: 'ENGLISH'},
    { value: 'fr', label: 'FRENCH'},
    { value: 'nl-BE', label: 'DUTCH_BE'},
    { value: 'nl', label: 'DUTCH_NL'},
    { value: 'hu', label: 'HUNGARIAN'}
];

export const isSupportedLang = (language: string): boolean => LANGUAGES.find((lang: Option) => lang.value === language) != null;

export const getLanguage = (): string => {
    let lang = localStorage.getItem('language');
    if (!lang) {
        LANGUAGES.forEach((l) => {
            if (navigator.language.includes(l.value)) {
                lang = l.value;
                return;
            }
        });
    }

    if (lang === 'nl_BE') {
        lang = 'nl-BE';
        localStorage.setItem('language', lang);
    }

    return lang && isSupportedLang(lang) ? lang : 'en';
};


export const updateLanguage = (lang: string,
                               appConfigService: AppConfigService,
                               translateService: TranslateService,
                               dateAdapter: DateAdapter<any>) => {
    const translateServiceLang = lang === 'nl'
        ? appConfigService.getAppConfig().opCo === 'NL01' ? 'nl' : 'nl-BE'
        : lang;
    translateService
        .use(translateServiceLang)
        .pipe(
            tap(() => {
                moment.locale(lang === 'en' ? 'en-GB' : lang);
                dateAdapter.setLocale(moment.locale());
                document.documentElement.setAttribute('lang', translateServiceLang);
            }),
            debounceTime(1)
        )
        .subscribe();
}
